// export const SET_PUBLIC_DSR_DISPLAY = 'set_public_dsr_display';
export const SET_NOTIFY_GEN_AI_ROOM_READY = 'set_notify_gen_ai_room_ready';
export const SET_GEN_AI_ROOM_READY_NOTIFICATION = 'set_gen_ai_room_ready_notification';

export const UPLOAD_GEN_AI_REFERENCE_FILE_REQUEST = 'upload_gen_ai_reference_file_request';
export const UPLOAD_GEN_AI_REFERENCE_FILE_SUCCESS = 'upload_gen_ai_reference_file_success';
export const UPLOAD_GEN_AI_REFERENCE_FILE_FAILURE = 'upload_gen_ai_reference_file_failure';
export const UPLOAD_GEN_AI_REFERENCE_FILE_RESET = 'upload_gen_ai_reference_file_reset';

export const CREATE_GEN_AI_ROOM_REQUEST = 'create_gen_ai_room_request';
export const CREATE_GEN_AI_ROOM_SUCCESS = 'create_gen_ai_room_success';
export const CREATE_GEN_AI_ROOM_FAILURE = 'create_gen_ai_room_failure';
export const CREATE_GEN_AI_ROOM_RESET = 'create_gen_ai_room_reset';